import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FlightHotelBoldIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.1278 4.03058C14.7575 4.03046 15.8133 4.05427 16.2885 4.16297C16.9885 4.32306 17.4864 4.66724 17.68 5.39018C17.6964 5.45153 17.6964 5.51568 17.68 5.57704C17.4839 6.30813 16.987 6.6502 16.2885 6.80743C15.8133 6.91441 14.7575 6.93581 14.1271 6.93596L13.3485 6.93618L11.6556 10.2829C11.383 10.7187 10.883 10.9868 10.3423 10.9869L9.82882 10.9951C9.70414 10.9951 9.58618 10.9426 9.50784 10.8521C9.42947 10.7617 9.39914 10.643 9.42529 10.5293L10.162 6.76361L8.09362 6.75586L7.14907 8.05004C7.07069 8.14139 6.95203 8.19466 6.82658 8.19465L5.71936 8.19482C5.58668 8.19482 5.4621 8.13533 5.38453 8.03491C5.30696 7.9345 5.28587 7.8054 5.32785 7.68793L6.11509 5.48528L5.32855 3.28283C5.2866 3.16537 5.30774 3.03622 5.38538 2.93574C5.46301 2.83526 5.58769 2.7757 5.72039 2.7757L6.82761 2.77554C6.95302 2.77551 7.0716 2.82868 7.1499 2.92004L8.09431 4.21364L10.1627 4.22139L9.42671 0.474307C9.40061 0.360556 9.43101 0.241863 9.50942 0.151367C9.58784 0.0608748 9.70588 0.00827427 9.83057 0.00825965L10.3441 1.59644e-08C10.8847 -7.55015e-05 11.3846 0.267773 11.6569 0.703406L13.3493 4.03078L14.1278 4.03058Z"
				fill="currentColor"
			/>
			<path
				d="M20.5 13.0178V11.5178H19C18.7239 11.5178 18.5 11.2939 18.5 11.0178C18.5 10.7416 18.7239 10.5178 19 10.5178H20.5V9.01778C20.5 8.74164 20.7239 8.51778 21 8.51778C21.2762 8.51778 21.5 8.74164 21.5 9.01778V10.5178H23C23.2762 10.5178 23.5 10.7416 23.5 11.0178C23.5 11.2939 23.2762 11.5178 23 11.5178H21.5V13.0178C21.5 13.2939 21.2762 13.5178 21 13.5178C20.7239 13.5178 20.5 13.2939 20.5 13.0178Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.00195 23.5127C6.00195 23.2365 6.22581 23.0127 6.50195 23.0127H16.502C16.7781 23.0127 17.002 23.2365 17.002 23.5127C17.002 23.7888 16.7781 24.0127 16.502 24.0127H6.50195C6.22581 24.0127 6.00195 23.7888 6.00195 23.5127Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.00195 16.0127C7.00195 14.4939 8.23315 13.2627 9.75195 13.2627H13.252C14.7708 13.2627 16.002 14.4939 16.002 16.0127V23.0127C16.002 23.4269 15.6662 23.7627 15.252 23.7627H11.502C11.9162 23.7627 12.252 23.4269 12.252 23.0127V21.7627C12.252 21.3485 11.9162 21.0127 11.502 21.0127C11.0878 21.0127 10.752 21.3485 10.752 21.7627V23.0127C10.752 23.4269 11.0878 23.7627 11.502 23.7627H7.75195C7.33775 23.7627 7.00195 23.4269 7.00195 23.0127V16.0127ZM9.75195 16.2627C9.75195 15.8485 10.0878 15.5127 10.502 15.5127H12.502C12.9162 15.5127 13.252 15.8485 13.252 16.2627C13.252 16.6769 12.9162 17.0127 12.502 17.0127H10.502C10.0878 17.0127 9.75195 16.6769 9.75195 16.2627ZM9.75195 18.7627C9.75195 18.3485 10.0878 18.0127 10.502 18.0127H12.502C12.9162 18.0127 13.252 18.3485 13.252 18.7627C13.252 19.1769 12.9162 19.5127 12.502 19.5127H10.502C10.0878 19.5127 9.75195 19.1769 9.75195 18.7627Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FlightHotelBoldIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FlightHotelBoldIcon;
